/* eslint-disable @typescript-eslint/no-explicit-any */
import { Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { ILeiData } from 'types/leiTypes';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import ContentCard from 'components/atoms/ContentCard';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import InfoTooltip from 'components/molecules/InfoTooltip';

import { ESubCategoryLei, ETypZadostiLei } from 'enums/lei/leiDataEnums';

interface IRozcestnikZalozeni {
    nextStep: () => void;
    setFormData: React.Dispatch<React.SetStateAction<ILeiData | undefined>>;
    setIsGovermentEntity?: React.Dispatch<React.SetStateAction<boolean>>;
}

const RozcestnikZalozeni: React.FC<IRozcestnikZalozeni> = ({ nextStep, setFormData, setIsGovermentEntity }) => {
    const { language, lei } = useContext(Context);
    const [govermentSubCategoryStep, setGovermentSubCategoryStep] = useState<boolean>(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => setIsGovermentEntity && setIsGovermentEntity(govermentSubCategoryStep), [govermentSubCategoryStep]);

    return (
        <>
            {lei?.loginless?.osoba?.uzivatelnovy ? (
                <Paragraph
                    text="EMAIL_OVERIT_KOD_TEXT"
                    style={{
                        paddingTop: 10,
                        display: 'block'
                    }}
                />
            ) : (
                !lei?.loginless && (
                    <>
                        <Paragraph
                            text="LEI_ROZCESTNIK_TEXT1"
                            style={{
                                paddingTop: 10,
                                display: 'block'
                            }}
                        />
                        <p
                            style={{
                                display: 'block'
                            }}
                        >
                            <TranslateText>LEI_SEZNAM</TranslateText>
                            <AnchorComponent href={'https://www.gleif.org'} target="_blank" id="gleifRedirectBtn">
                                www.gleif.org
                            </AnchorComponent>
                        </p>
                    </>
                )
            )}
            <div
                style={{
                    paddingTop: 30
                }}
            >
                {govermentSubCategoryStep && <Title level={5} text="LEI_RESIDENT_GOVERNMENT_ENTITY" />}
                <Paragraph
                    text={govermentSubCategoryStep ? 'LEI_ROZCESTNIK_CHOOSE_SUB' : 'LEI_ROZCESTNIK_CHOOSE'}
                    style={{
                        display: 'block'
                    }}
                />
            </div>
            {!govermentSubCategoryStep && (
                <Row
                    gutter={16}
                    justify="start"
                    style={{
                        paddingTop: 8
                    }}
                >
                    <ContentCard
                        onButtonclick={() => {
                            setFormData(pv => {
                                return {
                                    ...pv,
                                    typzadosti: ETypZadostiLei.GENERAL,
                                    matky: []
                                };
                            });
                            nextStep();
                        }}
                    >
                        <Title
                            level={5}
                            text={language === 'cz' ? 'LEI_GENERAL_BR' : 'LEI_GENERAL'}
                            style={{
                                margin: 0
                            }}
                        />
                        <InfoTooltip title={'LEI_GENERAL_TEXT'} />
                    </ContentCard>
                    <ContentCard
                        onButtonclick={() => {
                            setFormData(pv => {
                                return {
                                    ...pv,
                                    typzadosti: ETypZadostiLei.FUND,
                                    matky: []
                                };
                            });
                            nextStep();
                        }}
                    >
                        <Title
                            level={5}
                            text={language === 'cz' ? 'LEI_FUND_BR' : 'LEI_FUND'}
                            style={{
                                margin: 0
                            }}
                        />
                        <InfoTooltip title={'LEI_FUND_TEXT'} />
                    </ContentCard>
                    <ContentCard
                        onButtonclick={() => {
                            setFormData(pv => {
                                return {
                                    ...pv,
                                    typzadosti: ETypZadostiLei.BRANCH
                                };
                            });
                            nextStep();
                        }}
                    >
                        <Title
                            level={5}
                            text={language === 'cz' ? 'LEI_BRANCH_BR' : 'LEI_BRANCH'}
                            style={{
                                margin: 0
                            }}
                        />
                        <InfoTooltip title={'LEI_BRANCH_TEXT'} />
                    </ContentCard>
                    <ContentCard
                        onButtonclick={() => {
                            setFormData(pv => {
                                return {
                                    ...pv,
                                    typzadosti: ETypZadostiLei.SOLE_PROPRIETOR,
                                    matky: []
                                };
                            });
                            nextStep();
                        }}
                    >
                        <Title
                            level={5}
                            text={language === 'cz' ? 'LEI_SOLE_PROPRIETOR_BR' : 'LEI_SOLE_PROPRIETOR'}
                            style={{
                                margin: 0
                            }}
                        />
                        <InfoTooltip title={'LEI_SOLE_PROPRIETOR_TEXT'} />
                    </ContentCard>
                    <ContentCard
                        onButtonclick={() => {
                            setGovermentSubCategoryStep(true);
                        }}
                    >
                        <Title
                            level={5}
                            text={
                                language === 'cz'
                                    ? 'LEI_RESIDENT_GOVERNMENT_ENTITY_BR'
                                    : 'LEI_RESIDENT_GOVERNMENT_ENTITY'
                            }
                            style={{
                                margin: 0
                            }}
                        />
                        <InfoTooltip
                            title={
                                <>
                                    <TranslateText>LEI_RESIDENT_GOVERNMENT_ENTITY_TEXT</TranslateText>
                                    <div
                                        style={{
                                            paddingTop: 10,
                                            display: 'block'
                                        }}
                                    />
                                    <TranslateText>LEI_RESIDENT_GOVERNMENT_ENTITY_TEXT2</TranslateText>
                                </>
                            }
                        />
                    </ContentCard>
                    <ContentCard
                        onButtonclick={() => {
                            setFormData(pv => {
                                return {
                                    ...pv,
                                    typzadosti: ETypZadostiLei.INTERNATIONAL_ORGANIZATION,
                                    matky: []
                                };
                            });
                            nextStep();
                        }}
                    >
                        <Title
                            level={5}
                            text={
                                language === 'cz'
                                    ? 'LEI_INTERNATIONAL_ORGANIZATION_BR'
                                    : 'LEI_INTERNATIONAL_ORGANIZATION'
                            }
                            style={{
                                margin: 0
                            }}
                        />
                        <InfoTooltip title={'LEI_INTERNATIONAL_ORGANIZATION_TEXT'} />
                    </ContentCard>
                </Row>
            )}
            {govermentSubCategoryStep && (
                <>
                    <Row
                        gutter={16}
                        justify="start"
                        style={{
                            paddingTop: 8
                        }}
                    >
                        <ContentCard
                            small={true}
                            onButtonclick={() => {
                                setFormData(pv => {
                                    return {
                                        ...pv,
                                        subcategory: ESubCategoryLei.CENTRAL_GOVERNMENT,
                                        typzadosti: ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY,
                                        matky: []
                                    };
                                });
                                nextStep();
                            }}
                        >
                            <Title
                                level={5}
                                text={language === 'cz' ? 'CENTRAL_GOVERNMENT_BR' : 'CENTRAL_GOVERNMENT'}
                                style={{
                                    margin: 0
                                }}
                            />
                            <InfoTooltip
                                title={
                                    <>
                                        {' '}
                                        <TranslateText>CENTRAL_GOVERNMENT_SUB</TranslateText>
                                        <div
                                            style={{
                                                paddingTop: 14,
                                                display: 'block'
                                            }}
                                        />
                                        {language === 'cz' && (
                                            <TranslateText>CENTRAL_GOVERNMENT_SUB_NAPR</TranslateText>
                                        )}
                                    </>
                                }
                            />
                        </ContentCard>
                        <ContentCard
                            small={true}
                            onButtonclick={() => {
                                setFormData(pv => {
                                    return {
                                        ...pv,
                                        subcategory: ESubCategoryLei.STATE_GOVERNMENT,
                                        typzadosti: ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY,
                                        matky: []
                                    };
                                });
                                nextStep();
                            }}
                        >
                            <Title
                                level={5}
                                text={language === 'cz' ? 'STATE_GOVERNMENT_BR' : 'STATE_GOVERNMENT'}
                                style={{
                                    margin: 0
                                }}
                            />
                            <InfoTooltip
                                title={
                                    <>
                                        <TranslateText>STATE_GOVERNMENT_SUB</TranslateText>
                                        <div
                                            style={{
                                                paddingTop: 14,
                                                display: 'block'
                                            }}
                                        />
                                        {language === 'cz' && <TranslateText>STATE_GOVERNMENT_SUB_NAPR</TranslateText>}
                                    </>
                                }
                            />
                        </ContentCard>
                        <ContentCard
                            small={true}
                            onButtonclick={() => {
                                setFormData(pv => {
                                    return {
                                        ...pv,
                                        subcategory: ESubCategoryLei.LOCAL_GOVERNMENT,
                                        typzadosti: ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY,
                                        matky: []
                                    };
                                });
                                nextStep();
                            }}
                        >
                            <Title
                                level={5}
                                text={language === 'cz' ? 'LOCAL_GOVERNMENT_BR' : 'LOCAL_GOVERNMENT'}
                                style={{
                                    margin: 0
                                }}
                            />
                            <InfoTooltip
                                title={
                                    <>
                                        <TranslateText>LOCAL_GOVERNMENT_SUB</TranslateText>
                                        <div
                                            style={{
                                                paddingTop: 14,
                                                display: 'block'
                                            }}
                                        />
                                        {language === 'cz' && <TranslateText>LOCAL_GOVERNMENT_SUB_NAPR</TranslateText>}
                                    </>
                                }
                            />
                        </ContentCard>
                        <ContentCard
                            small={true}
                            onButtonclick={() => {
                                setFormData(pv => {
                                    return {
                                        ...pv,
                                        subcategory: ESubCategoryLei.SOCIAL_SECURITY,
                                        typzadosti: ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY,
                                        matky: []
                                    };
                                });
                                nextStep();
                            }}
                        >
                            <Title
                                level={5}
                                text={language === 'cz' ? 'SOCIAL_SECURITY_BR' : 'SOCIAL_SECURITY'}
                                style={{
                                    margin: 0
                                }}
                            />
                            <InfoTooltip
                                title={
                                    <>
                                        <TranslateText>SOCIAL_SECURITY_SUB</TranslateText>
                                        <div
                                            style={{
                                                paddingTop: 14,
                                                display: 'block'
                                            }}
                                        />
                                        {language === 'cz' && <TranslateText>SOCIAL_SECURITY_SUB_NAPR</TranslateText>}
                                    </>
                                }
                            />
                        </ContentCard>
                    </Row>
                    <Row className="button-row">
                        <ButtonComponent
                            id="rozcestnikZpetBtn"
                            buttontext="ZPET"
                            type="default"
                            htmlType="button"
                            onClick={() => setGovermentSubCategoryStep(false)}
                        />
                    </Row>
                </>
            )}
        </>
    );
};

export default RozcestnikZalozeni;
